/* special modes for data processing on api side */
export enum RideFetchDataMode {
  LiveMap = "LiveMap",
  /** Main rides / live-map grid search: one aggregate query for incidents in New status per ride. */
  RidesGrid = "RidesGrid",
}
